import {format} from "./components/common/Texts";
import bluedot from './images/blue-dot.png';

// Estrategia de selección cuando varias curvas pasan por el casillero (nivel +
// edad) de la persona. `curvas_posibles` queda ordenada de la curva más baja a
// la más alta.
export const CURVE_PICK = {
    // Siempre la más baja (la más conservadora).
    LOWEST: 'lowest',
    // Con 2 candidatas agarra la más alta, con 3 la del medio.
    SECOND: 'second',
};

// Cronología de estrategias. Cada tramo arranca en `from` y rige hasta el
// siguiente; la lista va del más nuevo al más viejo para resolver con el primer
// `from` que la fecha alcanza. Cada respuesta conserva la selección con la que
// se generó su reporte original, así que un cambio de criterio se agrega acá
// como tramo nuevo en vez de reescribir el pasado.
const CURVE_PICK_TIMELINE = [
    // 2026-08-08 en adelante: vuelta a la selección original.
    { from: new Date('2026-08-08T00:00:00'), pick: CURVE_PICK.SECOND },
    // 2026-07-04 a 2026-08-07: siempre la curva más baja.
    { from: new Date('2026-07-04T00:00:00'), pick: CURVE_PICK.LOWEST },
    // Hasta 2026-07-03: selección original.
    { from: new Date(0), pick: CURVE_PICK.SECOND },
];

// Estrategia para respuestas nuevas (las que no traen fecha de creación).
export const DEFAULT_CURVE_PICK = CURVE_PICK_TIMELINE[0].pick;

// Estrategia según la fecha de creación de la respuesta (created_date, como
// string ISO o Date). Sin fecha se asume respuesta nueva.
export function curvePickForReply(createdDate) {
    if (!createdDate) return DEFAULT_CURVE_PICK;
    const created = new Date(createdDate);
    if (Number.isNaN(created.getTime())) return DEFAULT_CURVE_PICK;
    const tramo = CURVE_PICK_TIMELINE.find(({ from }) => created >= from);
    return (tramo ?? CURVE_PICK_TIMELINE[CURVE_PICK_TIMELINE.length - 1]).pick;
}

function pickCurve(curvas_posibles, strategy) {
    if (curvas_posibles.length === 0) return -1;
    if (strategy === CURVE_PICK.SECOND && curvas_posibles.length > 1)
        return curvas_posibles[1];
    return curvas_posibles[0];
}

//ej 40, 4B -> 10
const niveles = ['1C','1B','1A','2C','2B','2A','3C','3B','3A','4C','4B','4A','5C','5B','5A', '6C','6B','6A','7C','7B','7A'];

const curvas = [[]];
//           1C,1B,1A,2C,2B,2A,3C,3B,3A,4C,4B,4A,5C,5B,5A, 6C,6B,6A
    curvas[0]= [32,43,0,  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // 0.1
    curvas[1]= [26,34,42, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // 1
    curvas[2]= [23,29,35,43, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // 1.1
    curvas[3]= [21,26,31,36,43,58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // 1.2
    curvas[4]= [ 20,24,28,32,37,44, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // 2
    curvas[5]= [ 19,22,25,29,34,39,48, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // 2.1
    curvas[6]= [ 18,20,23,27,31,35,42,53, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // 2.2
    curvas[7]= [ 0, 19,22,25,29,33,38,46,59, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // 2.3
    curvas[8]= [ 0, 18,20,23,27,30,34,41,51, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // 3
    curvas[9]= [ 0, 0, 19,22,25,28,32,37,45,53, 0, 0, 0, 0, 0, 0, 0, 0]; // 3.1
    curvas[10]=[ 0, 0, 18,20,23,27,30,35,41,48,59, 0, 0, 0, 0, 0, 0, 0]; // 3.2
    curvas[11]=[ 0, 0, 0, 19,22,25,29,33,38,44,52,64, 0, 0, 0, 0, 0, 0]; // 3.3
    curvas[12]=[ 0, 0, 0, 18,21,24,27,31,36,42,49,57, 0, 0, 0, 0, 0, 0]; // 4
    curvas[13]=[ 0, 0, 0, 0, 19,22,26,29,34,39,45,51,59, 0, 0, 0, 0, 0]; // 4.1
    curvas[14]=[ 0, 0, 0, 0, 18,21,24,28,32,37,42,48,53,62, 0, 0, 0, 0]; // 4.2
    curvas[15]=[ 0, 0, 0, 0, 0, 18,23,27,31,35,40,45,50,56,64, 0, 0, 0]; // 4.3
    curvas[16]=[ 0, 0, 0, 0, 0, 19,21,25,29,33,38,43,48,53,60, 0, 0, 0]; // 5
    curvas[17]=[ 0, 0, 0, 0, 0, 18,20,24,27,31,35,40,44,49,54,59, 0, 0]; // 5.1
    curvas[18]=[ 0, 0, 0, 0, 0, 0, 19,22,25,29,33,37,41,46,50,55,60, 0]; // 5.2
    curvas[19]=[ 0, 0, 0, 0, 0, 0, 18,21,24,28,31,35,39,43,48,52,56,61]; // 6
    curvas[20]=[ 0, 0, 0, 0, 0, 0, 0, 19,22,25,28,32,35,39,43,47,51,55]; // 6.1
    curvas[21]=[ 0, 0, 0, 0, 0, 0, 0, 18,20,23,26,29,33,36,40,44,47,51]; // 7
    curvas[22]=[ 0, 0, 0, 0, 0, 0, 0, 0,18 ,21,24,26,29,32,36,39,42,45]; // 7.1
    
    // ejemplos para probar: 3B , 31 tiene 3 (el hasta 31 hay que eliminarlo sino serian 4!)

    // el 595 deberia dar una curva mas alta VB o en. la base del VA
    // 23yrs 2A daba 12, 13 y 14. Ahora modifico la curva[12] de 21,23,26 a 21,24,27

// Nombre de cada curva de Jacques (el indice en `curvas` es interno; este es el
// nombre con el que se las conoce: 0.1, 1, 1.1, ... 7.1).
export const CURVE_NAMES = [
    '0.1', '1', '1.1', '1.2', '2', '2.1', '2.2', '2.3', '3', '3.1', '3.2', '3.3',
    '4', '4.1', '4.2', '4.3', '5', '5.1', '5.2', '6', '6.1', '7', '7.1',
];

// Nivel mas alto al que llega una curva ('4A'): el ultimo de su fila con una
// edad asignada. Vale para cualquier curva del modelo, tenga o no relacion con
// un casillero concreto.
export function getCurveTopLevel(curva) {
    const fila = curvas[curva];
    if (!fila) return '';
    let top = '';
    for (let i = 0; i < fila.length; i++) {
        if (fila[i] > 0) top = niveles[i];
    }
    return top;
}

// Niveles que una curva puede devolver como potencial, de menor a mayor
// ('1C' ... '6A'). Las filas de `curvas` llegan hasta 6A, asi que 7C..7A no son
// alcanzables como techo aunque existan en `niveles`.
export const POTENTIAL_LEVEL_CODES = niveles.slice(0, curvas[0].length);

// Posicion de un nivel+subnivel ('4B') en la tabla de curvas; -1 si no existe.
function levelPos(level) {
    return niveles.findIndex(nivel => nivel == String(level).toUpperCase());
}

// Approach 1 -> Buscar todas curvas posibles que pasen por mi casilla.
// Devuelve los indices de curva ordenados de la mas baja a la mas alta.
export function getPossibleCurves(age, level) {
    const pos = levelPos(level);
    let exit = false;
    let curvas_posibles = [];
    let i = 0;
    for (i = 0; i < curvas.length && !exit; i++) {
        if (curvas[i][pos] != 0 && curvas[i][pos] <= age) {
            if (curvas[i][pos + 1] <= age && curvas[i][pos + 1] > 0) {
                exit = true;

                if (curvas_posibles.length == 0)
                  curvas_posibles.push(i);
            }
            else {
/*
              if (esCurvaJaques(i)) {
                tuCurva = i;
                exit=true;
              }
              */
              curvas_posibles.push(i);
            }
        }
    }

    return curvas_posibles;
}

// Progresion de niveles futuros sobre una curva, arrancando en `pos`.
function getCurveProgression(tuCurva, pos, level, t) {
    let curvaArray=[];
    let nivelPot=level; // Inicializo en el que esta ahora por si no avanza nada
    let exit = false;
    let i=pos+1;
    while (!exit && i <curvas[tuCurva].length){
        if (curvas[tuCurva][i] > 0) {
            nivelPot=niveles[i];
            curvaArray.push({age:curvas[tuCurva][i], level: niveles[i], nivel:niveles[i].charAt(0), subnivel:niveles[i].charAt(1), nivelTxt:getNivelTxt(niveles[i], t)})
        }
        else {
            exit=true;
        }
        i++;
    }

    return [nivelPot, curvaArray];
}

export function getPotentialTalentArray(age, level, t, curvePick = DEFAULT_CURVE_PICK) {
    const pos = levelPos(level);
    const curvas_posibles = getPossibleCurves(age, level);
    const tuCurva = pickCurve(curvas_posibles, curvePick);
    const [nivelPot, curvaArray] = getCurveProgression(tuCurva, pos, level, t);

    return [nivelPot, tuCurva, curvaArray, curvas[tuCurva][pos]]

  }

// Todas las curvas que pasan por el casillero (edad + nivel), con el potencial
// al que llega cada una y cual queda elegida segun la estrategia vigente.
// Pensado para la vista de etiquetado: muestra el abanico completo en vez del
// unico resultado que devuelve getPotentialTalentArray.
export function getPossibleCurvesDetail(age, level, t, curvePick = DEFAULT_CURVE_PICK) {
    const pos = levelPos(level);
    if (pos < 0 || age == null) return { curves: [], picked: -1 };

    const curvas_posibles = getPossibleCurves(age, level);
    const picked = pickCurve(curvas_posibles, curvePick);

    const curves = curvas_posibles.map((curva) => {
        const [nivelPot, progresion] = getCurveProgression(curva, pos, level, t);
        return {
            curva,
            nombre: CURVE_NAMES[curva],
            nivelPot,
            progresion,
            edadRangoActual: curvas[curva][pos],
        };
    });

    return { curves, picked };
}

  function getNivelTxt(nivel, t) {
    let nivelNum = nivel.charAt(0);

    switch(nivelNum) {
      case '2':
        return t('operative');
      case '3':
        return t('tactic');
      case '4':
        return t('strategic_func');
      case '5':
        return t('strategic_gen');
      case '6':
      case '7':
        return t('strategic_corp');
    }

    return nivelNum;

  }

  // curva_extra == -1 -> draw all midlines
  export function drawLines(ctx,curva_extra, age){
    const l1 = [0,  0.8,  1.55, 2.15,  2.8,    3.25,  3.65,  3.8,  3.85,   3.8];
    const l2 = [1.1, 2.3,  3.5,  4.6,  5.5,    6.0,   6.5,  6.75,   6.85,   6.8];
    const l3 = [2.9, 4.5,  5.9,  7.1,  7.9,    8.5,  9.0,  9.4,    9.7,   9.7];
    const l4 = [4.8, 6.4,  7.75,  8.75,  9.7,  10.4, 11.2,  11.8,  12.2,   12.6];
    const l5 = [6.3, 7.8,  9.1,  10.2,  11.2,   12.3, 13.3,  14.3,  15,   15.7];
    const l6 = [7.6, 9.2,  10.7,  11.9,  13.1,  14.3, 15.5,  16.7,  17.8,   18.6];
    const l7 = [8.7, 10.6,  12.1,  13.6, 15.0,  16.35, 17.7,  19,   20.2,   21.1];
    const l8 = [10, 12.2,   14,   15.7,  17.3,  18.8, 20.3,  21.5,  22.5,   23.5];

    // Curva 0
    ctx.beginPath();
    //ctx.moveTo(134,480);
    ctx.moveTo(152,485);
    //ctx.quadraticCurveTo(279,455,479,464);
    ctx.quadraticCurveTo(279,460,495,470);
    ctx.strokeStyle = "#006633";
    ctx.lineWidth = 2;
    ctx.stroke(); 

    drawLine(ctx,l1, true)  //1
    drawLine(ctx,l2, true)  //2
    drawLine(ctx,l3, true)  //3
    drawLine(ctx,l4, true)  //4
    drawLine(ctx,l5, true)  //5      
    drawLine(ctx,l6, true)  //6
    drawLine(ctx,l7, true)  //7
    drawLine(ctx,l8, true)  //8
    
    switch (curva_extra) {
      case -1:
        // Curva 0.1
        ctx.beginPath();
        ctx.moveTo(90,480);
        ctx.quadraticCurveTo(170,460,250,445);
        ctx.quadraticCurveTo(330,425,479,440);      
        ctx.strokeStyle = "#0000FF";
        ctx.lineWidth = 1;
        ctx.stroke(); 

        drawMidLines(ctx,l1,l2,2)
        drawMidLines(ctx,l2,l3,3)    
        drawMidLines(ctx,l3,l4,3)    
        drawMidLines(ctx,l4,l5,3)     
        drawMidLines(ctx,l5,l6,2)     
        drawMidLines(ctx,l6,l7,1)  
        drawMidLines(ctx,l7,l8,1)      
        break;
    
      case 0:
        ctx.beginPath();
        ctx.moveTo(90,480);
        ctx.quadraticCurveTo(170,460,250,445);
        ctx.quadraticCurveTo(330,425,479,440);      
        ctx.strokeStyle = "#0000FF";
        ctx.lineWidth = 1;
        ctx.stroke(); 
        break;
      case 1:
        drawMidLine(ctx,l1,age);
        break;
      case 2:
        drawMidLines(ctx,l1,l2,2,1,age);  //1.1
        break;
      case 3:
        drawMidLines(ctx,l1,l2,2,2,age);  //1.2
        break;
      case 4:
        drawMidLine(ctx,l2, age)  //2
        break;
      case 5:
        drawMidLines(ctx,l2,l3,3,1,age);  //2.1
        break;
      case 6:
        drawMidLines(ctx,l2,l3,3,2,age);  //2.2
        break;
      case 7:
        drawMidLines(ctx,l2,l3,3,3,age);  //2.3
        break;
      case 8:
        drawMidLine(ctx,l3, age)  //3
        break;
      case 9:
        drawMidLines(ctx,l3,l4,3,1,age);  //3.1
        break;
      case 10:
        drawMidLines(ctx,l3,l4,3,2,age);  //3.2
        break;
      case 11:
        drawMidLines(ctx,l3,l4,3,3,age);  //3.3
        break;
      case 12:
        drawMidLine(ctx,l4, age)  //4
        break;
      case 13:
        drawMidLines(ctx,l4,l5,3,1,age);  //4.1
        break;
      case 14:
        drawMidLines(ctx,l4,l5,3,2, age);  //4.2
        break;
      case 15:
        drawMidLines(ctx,l4,l5,3,3, age);  //4.3
        break;
      case 16:
        drawMidLine(ctx,l5, age)  //5
        break;
      case 17:
        drawMidLines(ctx,l5,l6,2,1, age);  //5.1
        break;
      case 18:
        drawMidLines(ctx,l5,l6,2,2, age);  //5.2
        break;
      case 19:
        drawMidLine(ctx,l6, age)  //6
        break;
      case 20:
        drawMidLines(ctx,l6,l7,2,1, age);  //6.1
        break;
      case 21:
        drawMidLine(ctx,l7, age)  //7
        break;
      case 22:
        drawMidLines(ctx,l7,l8,2,1, age);  //7.1
        break;
      case 23: //prueba
       // const lt1 = [  7.74,  7.9,    8.5,  9.0,  9.4,    9.7,   9.9];
      //  const lt2 = [  9.51,  9.7,  10.4, 11.2,  11.8,  12.2,   12.7];
        //drawMidLines(ctx,lt1,lt2,3,3,40 );  //prueba
        break;

    }

  }

    // l1 - top line
  // l2 - bottom line
  // lines_to_draw -> number of middle lines to draw
  // draw_only == -1 -> draw all middle lines
  // draw_only = 0 -> draw first line only
  // draw_only = 1 -> draw second line only...

  function drawMidLines(ctx,l1, l2, lines_to_draw, draw_only=-1, age=20) {
    let points=[]
    let a=0.0
    let b=0.0
    let p=0.0
    for (let i=1; i<= lines_to_draw; i++) {
      points = []
      if (draw_only ==-1 || draw_only ==i) {
        for (let j=0; j<l1.length; j++) {
          a=l1[j];
          b=l2[j];
          p=(b-a)/(lines_to_draw+1) *i + a
          points.push(p)
        }
        drawMidLine(ctx,points, age)  
      //    drawLine(ctx,points)  
      }
    }
  }


   function  drawMidLine(ctx, stops, age) {


        let points =[];

        //                  20      25    30     35     40     45    50    55     60    65
        //                  [3.849, 5.45, 6.825, 7.925, 8.8,  9.45, 10.1, 10.6, 10.95, 11.3];
        
        // Ej 1: age = 39

        // (39-20) div 5  => 3  mod 5 => 4
        // stops[3] = 35 yrs 7.1
        // stops[4] = 40 yrs 7.9
        // start point = 7.1 + (7.9-7.1) * 4/5 = 7.74
        // end point = 7.9

        const x_vacio = age - 20
        const pos_edad = Math.floor(x_vacio/5); // posicion en el array segun edad
        const extra_edad = x_vacio % 5; // años proporcionales a sumar (de 0 a 4)
        let start_pointy = 0
        if (age < 65)
          start_pointy = stops[pos_edad] + (stops[pos_edad+1] -stops[pos_edad]) * extra_edad/5
        else 
          start_pointy = stops[pos_edad]

        let img2 = new Image();
        img2.src = bluedot;
        const {x,y} =  getCoords(age,start_pointy)
        img2.onload = () => {
          ctx.drawImage(img2, x-4, y-4)
        }

        if (age >= 65) 
          return; // No dibujar lineas

        points.push(getCoords(age,start_pointy))


        let i=0;
        for (i=pos_edad+1; i<stops.length; i++) {
          points.push( getCoords(20+(5*i),stops[i]))
        }
            
        ctx.beginPath();
        ctx.strokeStyle = "#0000FF";
        ctx.lineWidth = 2;
        ctx.setLineDash([10, 5]);/*dashes are 5px and spaces are 3px*/

        ctx.moveTo(points[0].x, points[0].y);
        
        if (points.length >=3) {
          for (i = 1; i < points.length - 2; i ++) {
            var xc = (points[i].x + points[i + 1].x) / 2;
            var yc = (points[i].y + points[i + 1].y) / 2;
            ctx.quadraticCurveTo(points[i].x, points[i].y, xc, yc);
          }
          // curve through the last two points
          ctx.quadraticCurveTo(points[i].x, points[i].y, points[i+1].x,points[i+1].y);
        }
        else
          ctx.quadraticCurveTo(points[0].x, points[0].y, points[1].x,points[1].y);
        ctx.stroke();  
    }

    // Cada stop es el nivel a una determinada edad empezando por 20
    export function     drawLine(ctx, stops, jacques=false) {
        let points =[];
        //points.push( getCoords(20,startLevel))
        let age = 20;
        let i=0;
        for (i=0; i<stops.length; i++) {
          points.push( getCoords(age+(5*i),stops[i]))
        }
            
        ctx.beginPath();
        if (jacques) {
          ctx.strokeStyle = "#006633";
          ctx.lineWidth = 2;
        }
        else {
          ctx.strokeStyle = "#0000FF";
          ctx.lineWidth = 2;
          ctx.setLineDash([10, 5]);/*dashes are 5px and spaces are 3px*/
        }
        ctx.moveTo(points[0].x, points[0].y);
        
        for (i = 1; i < points.length - 2; i ++) {
            var xc = (points[i].x + points[i + 1].x) / 2;
            var yc = (points[i].y + points[i + 1].y) / 2;
            ctx.quadraticCurveTo(points[i].x, points[i].y, xc, yc);
         }
       // curve through the last two points
        ctx.quadraticCurveTo(points[i].x, points[i].y, points[i+1].x,points[i+1].y);
        ctx.stroke();  
    }

   export function mapToMlLevel(level,sublevel)
{
    let ml_level = (level -1) *3
    switch(sublevel){
      case 'A': ml_level +=3; break;
      case 'B': ml_level +=2; break;
      case 'C': ml_level +=1; break;
    }

    if (level == 1) // El 1 tiene hasta D
      ml_level ++

    return ml_level

}  

    export function getCoordsWide(age, level) {
      const x = Math.round(15 * (age -20) + 60);
      const  y = Math.round(-20*level +472);
        return {x,y}
      }

    export function getCoords(age, level) {
      //const x = Math.round(9.33 * age -127);
      const x = Math.round(9.33 * age -111);
      const  y = Math.round(-20*level +480);
    
        return {x,y}
      }

      function bpl(s) {
        return `• ${s}\n`;
      }
      
      export function getReport(nivel, subnivel, progresionJacques, nombre, t) {
        let reporte='';
        let lastlevel=nivel;

        let quedan = progresionJacques.length; // 0 = final, >0 = sigue
        reporte=reporte + getReportByLevel(nivel  + subnivel, quedan, nombre, t);
        let futureTextArray = getFutureTextArray(t);

        if (progresionJacques.length > 0)
          futureTextArray[nivel+subnivel].data.leido = true;  // Ej si en presente es 3A y en futuro es 3B hay que marcarlo leido para q no lo muestre de nuevo
        for (let i=0; i< progresionJacques.length; i++ ) {
      
          let pj = progresionJacques[i];
          quedan = (progresionJacques.length -1 -i);

         if (lastlevel !=  pj.nivel)  {
            // Salto de nivel
            reporte = reporte + bpl(format(t('cap_inc_level'), pj.age, pj.nivelTxt));
            lastlevel=pj.nivel;
         }

         let futureText = futureTextArray[pj.level];
         if (!futureText.data.leido) {
            reporte = reporte + futureText.data.texto;
            futureText.data.leido = true;
         }

         // Solo hubo un movimiento al 4A o 3A
         if (quedan === 0 && !(progresionJacques.length === 1 && pj.level !== '4A' && pj.level !== '3A'))
            reporte = reporte + futureText.finalText;

         reporte+= '\n';

      }
      return reporte;
        }
        
  function getReportByLevel(level, quedan, nombre, t) {
    let resp = '';

    const hash = nombre.length;
    const multi_bpl = (...keys) => keys.map(k => bpl(t(k))).join('');

    if (level.substring(0,1) === '1')
      return multi_bpl('level_1_1', 'level_1_2', 'level_1_3', 'level_1_4') + '\n';

    if (level === '2C'|| level === '2B'){
       resp = multi_bpl('level_2B_2C_1', 'level_2B_2C_2', 'level_2B_2C_3', 'level_2B_2C_4');

       // Candidate finishes in 2A
       if ((level === '2C' && quedan === 2) || (level === '2B' && quedan === 1))
         resp += multi_bpl('level_2B_2C_extra_1', 'level_2B_2C_extra_2', 'level_2B_2C_extra_3', 'level_2B_2C_extra_4');

       return resp + '\n';
    }

    if (level === '2A' ) {
      resp = (hash % 2 === 0) ?
        multi_bpl('level_2A_1_1', 'level_2A_1_2', 'level_2A_1_3', 'level_2A_1_4', 'level_2A_1_5') :
        multi_bpl('level_2A_2_1', 'level_2A_2_2', 'level_2A_2_3', 'level_2A_2_4', 'level_2A_2_5');

      if (quedan === 0)
        resp += multi_bpl('level_2A_extra_1', 'level_2A_extra_2', 'level_2A_extra_3', 'level_2A_extra_4', 'level_2A_extra_5');

      return resp + '\n';
    }

    if (level === '3C') {
      resp = (hash % 2 === 0) ?
        multi_bpl('level_3C_1', 'level_3C_2', 'level_3C_3', 'level_3C_4', 'level_3C_5') :
        multi_bpl('level_3C_6', 'level_3C_7', 'level_3C_8', 'level_3C_9');

      if (quedan === 0)
        resp += multi_bpl('level_3C_extra_1', 'level_3C_extra_2', 'level_3C_extra_3', 'level_3C_extra_4');

      return resp + '\n';
    }

    if (level === '3B' || level === '3A') {
      const ending = multi_bpl('level_3A_3B_extra_1', 'level_3A_3B_extra_2', 'level_3A_3B_extra_3', 'level_3A_3B_extra_4', 'level_3A_3B_extra_5');

      if (level === '3B'){
        resp = (hash % 2 === 0) ? multi_bpl('level_3B_1', 'level_3B_2', 'level_3B_3', 'level_3B_4') : multi_bpl( 'level_3B_5', 'level_3B_6', 'level_3B_7', 'level_3B_8');

        if (quedan <= 1)
          resp += ending;
      } else {
        resp = multi_bpl('level_3A_1', 'level_3A_2', 'level_3A_3');

        if (quedan === 0)
          resp += ending;
      }

      return resp + '\n';
    }

    if (level === '4C'){
      resp = multi_bpl('level_4C_1', 'level_4C_2', 'level_4C_3', 'level_4C_4');

      if (quedan === 0)
        resp += multi_bpl('level_4C_extra_1', 'level_4C_extra_2', 'level_4C_extra_3', 'level_4C_extra_4', 'level_4C_extra_5');

      return resp + '\n';
  }

    if (level === '4B' || level === '4A') {
      resp = multi_bpl('level_4A_4B_1', 'level_4A_4B_2', 'level_4A_4B_3', 'level_4A_4B_4', 'level_4A_4B_5');

      if ((level === '4B' && quedan <= 1) || (level === '4A' && quedan === 0)) {
        resp += multi_bpl('level_4A_4B_extra_1', 'level_4A_4B_extra_2', 'level_4A_4B_extra_3', 'level_4A_4B_extra_4', 'level_4A_4B_extra_5');
      }

      return resp + '\n';
    }

    if (level.substring(0,1) === '5'){
      resp = multi_bpl('level_5_1', 'level_5_2', 'level_5_3', 'level_5_4');

      if (quedan === 0) {
        if (level.charAt(1) === 'C') {
          resp += bpl(format('level_5C_extra', 5, 7));
          resp += multi_bpl('level_5C_extra_1', 'level_5C_extra_2');
        } else {
          resp += bpl(format('level_5C_extra', 7, 10));
          resp += multi_bpl('level_5C_extra_3', 'level_5C_extra_4');
        }
      }

      return resp + '\n';
    }

    if (level.substring(0,1) === '6')
      return multi_bpl('level_6_1', 'level_6_2', 'level_6_3', 'level_6_4', 'level_6_5', 'level_6_6') + '\n';
}


  function getFutureTextArray(t) {
    let futureTextArray=[];

    const multi_bpl = (...keys) => keys.map(k => bpl(t(k))).join('');

    futureTextArray['2C'] = {
      data:{texto:'', leido:true},
      finalText:''
    }

    const text2AB= {
    texto: multi_bpl('future_2A_2B_1', 'future_2A_2B_2', 'future_2A_2B_3'),
    leido:false
  }

    futureTextArray['2B'] = {
      data:text2AB,
      finalText:''
    }

    futureTextArray['2A'] = {
      data:text2AB,
      finalText:''
    }

    const text3C={
      texto: multi_bpl('future_3C_1', 'future_3C_2', 'future_3C_3', 'future_3C_4', 'future_3C_5'),
      leido:false
    }

    futureTextArray['3C'] = {
      data:text3C,
      finalText: bpl(t('future_3C_6'))
    }

    const text3AB= {
      texto: multi_bpl('future_3A_3B_1', 'future_3A_3B_2', 'future_3A_3B_3', 'future_3A_3B_4', 'future_3A_3B_5', 'future_3A_3B_6'),
      leido: false
    }

    const finalText3AB= bpl(t('future_3A_3B_7'));

    futureTextArray['3B'] = {
      data:text3AB,
      finalText:finalText3AB
    }

    futureTextArray['3A'] = {
      data:text3AB,
      finalText:finalText3AB
    }


    const text4C={
      texto: multi_bpl('future_4C_1', 'future_4C_2', 'future_4C_3', 'future_4C_4'),
      leido: false
    }
    
    futureTextArray['4C'] = {
      data: text4C,
      finalText: multi_bpl('future_4C_5', 'future_4C_6')
    }
     
    const text4AB={
      texto: multi_bpl('future_4A_4B_1', 'future_4A_4B_2', 'future_4A_4B_3'),
      leido: false
    }

    const finalText4AB= multi_bpl('future_4A_4B_4', 'future_4A_4B_5', 'future_4A_4B_6', 'future_4A_4B_7');

    futureTextArray['4B'] = {
      data:text4AB,
      finalText:finalText4AB
    }

    futureTextArray['4A'] = {
      data:text4AB,
      finalText:finalText4AB
    }

    const text5={
      texto: multi_bpl('future_5_1', 'future_5_2', 'future_5_3'),
      leido: false
    }

    futureTextArray['5C'] = {
      data:text5,
      finalText: bpl(format(t('future_5_8'), 5, 7)) + '\n' + multi_bpl('future_5_4', 'future_5_5', 'future_5_6', 'future_5_7')
    }

    const final5AB= multi_bpl('future_5_9', 'future_5_10', 'future_5_6', 'future_5_7');

    futureTextArray['5B'] = {
      data:text5,
      finalText: final5AB
    }

    futureTextArray['5A'] = {
      data:text5,
      finalText: final5AB
    }

    const text6={
      texto: multi_bpl('future_6_1', 'future_6_2', 'future_6_3', 'future_6_4', 'future_6_5', 'future_6_6', 'future_6_7'),
      leido: false
    }

    futureTextArray['6C'] = {
      data:text6,
      finalText:''
    }

    futureTextArray['6B'] = {
      data:text6,
      finalText:''
    }

    futureTextArray['6A'] = {
      data:text6,
      finalText:''
    }
 
    return futureTextArray;
  }
